// extracted by mini-css-extract-plugin
module.exports = {"loader":"zd","smallLoader":"Ad","loading-keyframes":"Bd","pageLoader":"Cd","centered":"Dd","whitespacePlaceholder":"Ed","buttonSpinner":"Fd","fade-in":"Gd","rotate":"Hd"};